import { useCategories } from "@/query/useCategories";
import { useRestaurant } from "@/query/useRestaurant";
import { useWorkingHours } from "@/query/useWorkingHours";
import { restaurantService } from "@/service/restaurantService";
import { useEffect, useState } from "react";
import { useParams } from "react-router";


export function useRestaurantDataLoader() {
  const { restaurantId } = useParams<{ restaurantId: string }>();

  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const { data: restaurant, isLoading: isLoadingRestaurant, error: restaurantError } = useRestaurant(restaurantId ?? "", restaurantService.getSubdomain());
  const { data: categories, isLoading: isLoadingCategories, error: categoriesError } = useCategories(restaurant?.id ?? "");
  const { data: workingHours, isLoading: isLoadingWorkingHours, error: workingHoursError } = useWorkingHours(restaurant?.id ?? "");

  useEffect(() => {
    if (categories && categories.length > 0) {      
      setActiveCategory(categories[0].id || null);
    }
  }, [categories]);

  useEffect(() => {
    if (categoriesError) {
      setError(typeof categoriesError === "string" ? categoriesError : categoriesError.message);
    }
    if (restaurantError) {
      setError(typeof restaurantError === "string" ? restaurantError : restaurantError.message);
    }

    if (workingHoursError) {
      setError(typeof workingHoursError === "string" ? workingHoursError : workingHoursError.message);
    }
    return () => {
      setLoading(false);
    };
  }, [categoriesError, restaurantError, workingHoursError]);

  useEffect(() => {
    setLoading(isLoadingRestaurant || isLoadingCategories || isLoadingWorkingHours);
  }, [isLoadingRestaurant, isLoadingCategories, isLoadingWorkingHours]);

  return { restaurantData: restaurant, categories, workingHours, activeCategory, loading, error };
}

